import { render, staticRenderFns } from "./CameraDetail.vue?vue&type=template&id=5899123c&scoped=true&"
import script from "./CameraDetail.vue?vue&type=script&lang=js&"
export * from "./CameraDetail.vue?vue&type=script&lang=js&"
import style0 from "./CameraDetail.vue?vue&type=style&index=0&id=5899123c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5899123c",
  null
  
)

export default component.exports